<template>
  <a-modal
    :visible="visible"
    centered
    @cancel="handleCancel"
    width="30%"
    :title="title"
    :footer="false"
  >
    <a-row :gutter="[8, 32]">
      <a-form
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 8}"
        :form="form"
      >
        <a-col>
          <a-form-item :label="$t('conseilClass.auto')">
            <div class="d-flex align-items-center">
              <a-switch
                v-decorator="[
                  'auto',
                  {
                    initialValue: defaultData.auto,
                    valuePropName: 'checked',
                  },
                ]"
                @change="(val)=>disabled=val"
              />
            </div>
          </a-form-item>
        </a-col>
        <a-col>
          <a-form-item :label="$t('bulletinBuilder.taille')">
            <div class="d-flex align-items-center">
              <a-input
                type="number"
                :min="1"
                :max="20"
                :disabled="disabled"
                v-decorator="[
                  'size',
                  {
                    initialValue: defaultData.size,
                  },
                ]"
              />
            </div>
          </a-form-item>
        </a-col>        
      </a-form>
    </a-row>
    <a-row :gutter="[8, 32]">
      <a-col :span="12" :offset="12">
        <a-button type="primary" class="w-100" @click="save">
          <a-icon type="save" />{{ $t("all.apply") }}
        </a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>

export default {
  name: "ConfigTableModal",
  props: {
    config: {
      type: Object,
      required: true,
    },
    defaultData: {
      type: Object,
      required: true,
    },    
    visible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },

  },
  data() {
    return {
      form: this.$form.createForm(this),
      disabled:true
    }
  },
  mounted(){
    this.disabled = this.defaultData.auto
  },
  methods: {
    save() {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) this.$emit("save", values);
      });
    },
    handleCancel() {
      this.$emit("cancel");
    },
  },
};
</script>
